import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AdmissionPageRoutingModule } from './admission-routing.module';

import { AdmissionPage } from './admission.page';
import { NavbarComponent } from '../navbar/navbar.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AdmissionPageRoutingModule
  ],
  declarations: [AdmissionPage,NavbarComponent]
})
export class AdmissionPageModule {}
